import {Layout} from '../../src/Layout';
export default Layout;

import {ColorSlider} from '@react-spectrum/s2';
import docs from 'docs:@react-spectrum/s2';

# ColorSlider

<PageDescription>{docs.exports.ColorSlider.description}</PageDescription>

<VisualExample
  component={ColorSlider}
  docs={docs.exports.ColorSlider}
  links={docs.links}
  props={['label', 'colorSpace', 'channel', 'orientation', 'contextualHelp', 'isDisabled']}
  initialProps={{channel: 'hue', defaultValue: 'hsl(0, 100%, 50%)'}}
  importSource="@react-spectrum/s2"
  type="s2" />

## Value

Use the `value` or `defaultValue` prop to set the color value, and the `channel` prop to specify which color channel to display. The value may be a string or <TypeLink type={docs.exports.Color} links={docs.links} /> object, parsed using the <TypeLink type={docs.exports.parseColor} links={docs.links} /> function.

The `onChange` event is called as the user drags, and `onChangeEnd` is called when the thumb is released. These are always called with a `Color` object.

```tsx render
"use client";
import {ColorSlider, parseColor} from '@react-spectrum/s2';
import {useState} from 'react';

function Example() {
  let [currentValue, setCurrentValue] = useState(parseColor('hsl(50, 100%, 50%)'));
  let [finalValue, setFinalValue] = useState(currentValue);

  return (
    <>
      <ColorSlider
        channel="hue"
        /*- begin highlight -*/
        value={currentValue}
        onChange={setCurrentValue}
        onChangeEnd={setFinalValue} />
        {/*- end highlight -*/}
      <pre style={{fontSize: 12}}>
        onChange value: {currentValue.toString('hex')}{'\n'}
        onChangeEnd value: {finalValue.toString('hex')}
      </pre>
    </>
  );
}
```

## API

<PropTable component={docs.exports.ColorSlider} links={docs.links} />
